import React from 'react';
import { Hero } from '../components/Hero';
import { WhyChoose } from '../components/WhyChoose';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { ServiceAreas } from '../components/ServiceAreas';
import { Newsletter } from '../components/Newsletter';
import { MovingText } from '../components/MovingText';
import { MovingTextAlt } from '../components/MovingTextAlt';

export default function HomePage() {
  return (
    <>
      <Hero />
      <MovingTextAlt />
      <WhyChoose />
      <Services />
      <Testimonials />
      <ServiceAreas />
      <Newsletter />
    </>
  );
}